<template>
	<div class="policylibrary qualityenterprise">
		<leftnav class="fl" :mkcode="(curWebsite.type == 5 || curWebsite.type == 6) ? 'T' : 'B'" itemcode="B-CYZC"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox">
					<div class="right_boxtitle map_title_tab ">
						<span class="title" :class="{ 'current': pageType == 2 }" @click="pageType = 2;kw = '';getlist2();">招商政策</span>
						<!-- <span class="title" :class="{ 'current': pageType == 1 }" @click="pageType = 1;kw = '';getlist1();">产业政策</span> -->
						<div class="fl search-box nz-search-box">
							<span class="searchtype">{{pageType == 1?'产业':'招商'}}政策</span>
							<input type="text" placeholder="请输入政策关键词" class="search-input" v-model="kw"
								@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun()">查询</button>
						</div>
					</div>
					<!-- 产业政策筛选项 -->
					<div class="opport-screen-list1" v-show="pageType == 1">
						<div class="spage-searchbox ">
							<dl class="opport-screen bdbe">
								<dt class="fl">政策利弊</dt>
								<dd class="fl">
									<span @click="radiochoose(0)"
										:class="radioid == 0 ? 'a-screen current' : 'a-screen'">不限</span>
									<span @click="radiochoose(1)"
										:class="radioid == 1 ? 'a-screen current' : 'a-screen'">利好</span>
									<span @click="radiochoose(2)"
										:class="radioid == 2 ? 'a-screen current' : 'a-screen'">利空</span>
									<video-teaching :type="2"></video-teaching>
								</dd>

							</dl>
							<dl class="opport-screen bdbe">
								<dt class="fl">产业分类</dt>
								<dd class="fl screenop">
									<span @click="chooseNotion(1, 'a', { lable: '全部', value: 0, children: [] })"
										:class="notionCode == 0 ? 'a-screen current' : 'a-screen'">全部</span>
									<span v-for="(item, index) in notionlist" :key="'notion1' + index"
										v-show="item.label.indexOf('制造业') > -1"
										:class="chooseNotionlist[0] == item.value ? 'a-screen current' : 'a-screen'"
										@click="chooseNotion(1, 'a', item)">{{ item.label }}</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe" v-show="notionlist1.length > 0">
								<dt class="fl titleop">一级产业</dt>
								<dd class="fl">
									<span @click="chooseNotion(2, 'all', fenkd)"
										:class="chooseNotionlist[1] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
									<span v-for="(item, index) in notionlist1" :key="'notion2' + index"
										:class="chooseNotionlist[1] == item.value ? 'a-screen current' : 'a-screen'"
										@click="chooseNotion(2, 'a', item)">{{ item.label }}</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe" v-show="notionlist2.length > 0">
								<dt class="fl titleop">二级细分</dt>
								<dd class="fl">
									<span @click="chooseNotion(3, 'all', fenkd)"
										:class="chooseNotionlist[2] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
									<span v-for="(item, index) in notionlist2" :key="'notion3' + index"
										:class="chooseNotionlist[2] == item.value ? 'a-screen current' : 'a-screen'"
										@click="chooseNotion(3, 'a', item)">{{ item.label }}</span>
								</dd>
							</dl>
						</div>
					</div>
					<!-- 招商政策筛选项 -->
					<div class="opport-screen-list1" v-show="pageType == 2">
						<div class="spage-searchbox ">
							<!-- 省市区筛选 -->
							<cityScreen @getEnterpriseList="cityScreenFun" :ischoose="false"></cityScreen>
							<dl class="opport-screen bdbe">
								<dt class="fl">级别</dt>
								<dd class="fl">
									<span @click="isShowFreeUserTips=true" :class="levelValue == '' ? 'a-screen current' : 'a-screen'">全部</span>
									<span v-for="(item, index) in levelOptions " :key="'leval' + index"
										@click="isShowFreeUserTips=true"
										:class="levelValue == item.paraValue ? 'a-screen current' : 'a-screen'">{{
											item.paraName }}</span>
									<video-teaching :type="2"></video-teaching>
								</dd>
							</dl>
							<dl class="opport-screen bdbe">
								<dt class="fl">发文机构</dt>
								<dd class="fl">
									<span @click="isShowFreeUserTips = true"
										:class="postingValue == '' ? 'a-screen current' : 'a-screen'">全部</span>
									<span v-for="(item, index) in postingOptions " :key="'leval' + index"
										@click="isShowFreeUserTips = true"
										:class="postingValue == item.paraValue ? 'a-screen current' : 'a-screen'">{{
											item.paraName }}</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe">
								<dt class="fl">政策标签</dt>
								<dd class="fl">
									<span @click="isShowFreeUserTips = true"
										:class="policyLabelValue == '' ? 'a-screen current' : 'a-screen'">全部</span>
									<span v-for="(item, index) in policyLabelOptions " :key="'leval' + index"
										@click="isShowFreeUserTips = true"
										:class="policyLabelValue == item.paraValue ? 'a-screen current' : 'a-screen'">{{
											item.paraName }}</span>
								</dd>
							</dl>
							<!-- <dl class="opport-screen bdbe">
						<dd class="fl">
							<span v-for="(item, index) in policyTypeOptions " :key="'leval' + index"
								@click="policyTypeChose(item)"
								:class="policyTypeValue == item.value ? 'a-screen current' : 'a-screen'">{{ item.label + ' ' + item.num }}</span>
							<span class="policy-short-btn a-screen" @click="sortFun()"><el-icon class="el-icon-sort" :class="orderType == 0 ? '' : 'transform-rotateX180'"></el-icon>默认排序{{ orderType }}</span>
							</dd>	
					</dl> -->
						</div>
					</div>
				</div>
				
				<div class="whitebox" >
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
						<p class="fl" v-if="kwtextsearch">产业大脑为您找到<span class="searchnum">{{ total }}</span>条【 <span
							class="orangefont">{{ kwtextsearchtext }}</span>】相关结果</p>
					</div>
					<div class="enterprise_list_box"  v-show="pageType == 1">
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>发布时间</th>
								<th class="  policy_parkname1th">政策名称</th>
								<th>利弊</th>
								<!-- <th>影响力</th> -->
							</tr>
							<tr v-for="(item, i) in pagelist1" :key="i">
								<td>{{ item.publishTime }}</td>
								<td class="policy_parkname" @click="routerlinkid('/news', item.id, 1)">
									{{ item.title }}</td>
								<td>
									<span v-if="item.good == 1">利好</span>
									<span v-if="item.good == 2">利空</span>
								</td>
								<!-- 	<td><span :class="item.good==1?'stargrade1 redstargrade':'stargrade1 greenstargrade'" ><i class="" v-for="list in item.star"></i></span> </td> -->
								<!-- good=1 利好红色，good =2 利空 绿色-->
							</tr>
						</table>
					</div>
					<div class="information_content information_box" v-show="pageType == 2">
						<div class="infornews" :key="i" v-for="(list, i) in pagelist2">
							<div @click="routerlinkid('/news', list.id,7)" class="infornews_d">
								<h5 class="title"><span class="fl info_title">{{ list.title }}</span>
								</h5>
								<p class="onlyLine-text color-9f9">{{ list.summary }}</p>
							</div>
							<div class="basefont-nocur fz15 ">
								<el-tag size="small" class="mr-1" v-show="list.level">{{ list.level }}</el-tag>
								<el-tag size="small" class="mr-1" v-show="list.tag">{{ list.tag }}</el-tag>
								<el-tag size="small" class="mr-1" v-show="list.type">{{ list.type }}</el-tag>
							</div>
							<div class="pubilsh_info mt-15">
								<span class="pr-1 inline-block  color-666">{{ list.time }}</span>
								<el-divider direction="vertical"></el-divider>
								<span class="px-1 inline-block  color-666"> {{list.org2 || list.org}}</span>
								<!-- <span class="px-1 inline-block color-666 indtry"><em class="color-999">适用行业：</em>专业技术服务业专用设备制造业仪器仪表制造业;其他制造业;农副..</span> -->
							</div>
						</div>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
						</zpagenav>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { get } from "http";
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'index',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			curWebsite: this.$api.getWebsiteType(),
			title: "产业政策",
			notionCode: '', chooseNotionlist: [0, 0, 0, 0, 0], fenkd: { children: [] },
			notionlist1: [],
			notionlist2: [],
			notionlist3: [],
			notionlist4: [],
			notionlist5: [],
			radioid: 0,
			userdata: {},
			date: '', //日期选择 
			pagelist1: [],
			pagelist2: [],
			options: [],
			value: '',
			kw: '', //搜索关键词
			//-------------------------------
			searchtype: 1,
			searchtype1: 1,
			searchtext: "",
			kwtextsearch: false,
			kwtextsearchtext: "",
			notionbtn: false,
			notionlist: [{
				label: "先进制造业",
				value: "A"
			},],
			options1: {},
			options2: {},
			options3: {},
			flag: false,
			page: 1, //显示的是哪一页
			haspage: true, //是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数
			pageType: 2,
			// ---24.5.6招商政策---
			pagelist: [
				{ id: 1, title: '关于征集《上海市浦东新区创新药械产品目录》(第二批)的通知', publishTime: '2023-2-12', summary: "关于征集《上海市浦东新区创新药械产品目录》(第二批)的通知", categoryText: "区级", tag: '资产补贴' },
				{ id: 2, title: '政策名称2', publishTime: '2023-2-12', summary: "北极星氢能网获悉，4月16日，内蒙古自治区能源局等部门发布《内蒙古自治区可再生能源制氢产业安全管理办法（试行）》的通知。其中指出：允许在化工园区外建设绿氢项目和制氢加氢一体站。绿氢项目不需取得危险化学品安全生产许可。绿氢加氢", categoryText: "省级", tag: '研发补贴' },
				{ id: 3, title: '政策名称3', publishTime: '2023-2-12', summary: "北极星氢能网获悉，4月16日，内蒙古自治区能源局等部门发布《内蒙古自治区可再生能源制氢产业安全管理办法（试行）》的通知。其中指出：允许在化工园区外建设绿氢项目和制氢加氢一体站。绿氢项目不需取得危险化学品安全生产许可。绿氢加氢", categoryText: "国家级", tag: '研发补贴' },
				{ id: 4, title: '政策名称4', publishTime: '2023-2-12', summary: "北极星氢能网获悉，4月16日，内蒙古自治区能源局等部门发布《内蒙古自治区可再生能源制氢产业安全管理办法（试行）》的通知。其中指出：允许在化工园区外建设绿氢项目和制氢加氢一体站。绿氢项目不需取得危险化学品安全生产许可。绿氢加氢", categoryText: "区级", tag: '研发补贴' },
				{ id: 5, title: '政策名称5', publishTime: '2023-2-12', summary: "北极星氢能网获悉，4月16日，内蒙古自治区能源局等部门发布《内蒙古自治区可再生能源制氢产业安全管理办法（试行）》的通知。其中指出：允许在化工园区外建设绿氢项目和制氢加氢一体站。绿氢项目不需取得危险化学品安全生产许可。绿氢加氢", categoryText: "市级", tag: '研发补贴' },
				{ id: 6, title: '政策名称6', publishTime: '2023-2-12', summary: "北极星氢能网获悉，4月16日，内蒙古自治区能源局等部门发布《内蒙古自治区可再生能源制氢产业安全管理办法（试行）》的通知。其中指出：允许在化工园区外建设绿氢项目和制氢加氢一体站。绿氢项目不需取得危险化学品安全生产许可。绿氢加氢", categoryText: "市级", tag: '研发补贴' },
			],
			levelOptions: [],
			levelValue: '',
			postingOptions: [],
			postingValue: '',
			policyLabelOptions: [],
			policyLabelValue: '',
			policyTypeOptions: [],
			policyTypeValue: '',
			orderType: 0,
			isShowFreeUserTips: false,
		}
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		this.userdata = this.getuseriformation();
		this.getCurrentTime();
	},
	mounted() {
		this.init();
	},
	methods: {
		init() {
			document.getElementById('app').style.background = "#f0f3f5";
			this.bus.$emit('loading', true);
			 
			var _this = this;
			//三大产业概念数据
			this.$axios.get(this.$api.tag.notion.list() + '?level=5').then(function (res) {
				// console.log(res.data)
				if (res.data.success) {
					console.log(res.data.list)
					_this.notionlist = res.data.list;
					_this.options1 = res.data.list[0].children;
					_this.options2 = res.data.list[1].children;
					_this.options3 = res.data.list[2].children;
					_this.flag = true;
					// _this.notionlist=res.data.list;  
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
			this.getlist2();
			this.getClassify();
		},
		//获取招商政策筛选分类
		getClassify() {
			this.bus.$emit('loading', true);
			return new Promise((resolve, reject) => {
				let ajaxurl = this.$api.free.policyParameter.list()+"?categoryId=-1";
				this.$axios.get(ajaxurl).then((res) =>{
					console.log("获取筛选分类", ajaxurl, res);
					if(res.data.success){
						let result = res.data;
						this.levelOptions = result.list[0].children || [];
						this.policyTypeOptions = result.list[1].children || [];
						this.policyLabelOptions = result.list[2].children || [];
						this.postingOptions = result.list[3].children || [];
						resolve(res);
					}else{
						// reject(res);
					}
				this.bus.$emit('loading', false);
				}).catch(function (error) {
					reject(error);
					// 请求失败处理 console.log(error);
				});
			});
		},
		//省份城市选择 
		cityScreenFun(pid, cid, cuid) {
			this.cityid = cid;
			this.countyid = cuid;
			this.provinceid = pid;
			this.getlist2();
		},
		getCurrentTime() {
			//获取当前时间
			var _this = this;
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			let hh = new Date().getHours();
			let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
			let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
			// 　　_this.gettime = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss; 
			this.time = yy + '-' + mm + '-' + dd + ' ';
		},
		//利好利空选择
		radiochoose(id) {
			this.radioid = id;
			this.getlist1();
		},
		//概念单选 层级显示
		chooseNotion(step, type, data) {
			this.isShowFreeUserTips = true;
			return;
			if (type == 'all') {
				this.notionCode = this.chooseNotionlist[step - 2];
				this.chooseNotionlist[step - 1] = '0';
			} else {
				this.chooseNotionlist[step - 1] = data.value;
				// this.chooseNotionlist[step]='0';
				for (var i = 0; i < this.chooseNotionlist.length; i++) {
					if (i > step - 1) {
						this.chooseNotionlist[i] = 0;
					}
				}
				this.notionCode = data.value;
			}
			if (data.children != null) {
				if (step == 1) {
					this.notionlist1 = data.children.filter(list => {
						return list.label != '环保';
					});
					// console.log(this.notionlist1)
					this.notionlist2 = []; this.notionlist3 = []; this.notionlist4 = [];
				} else if (step == 2) {
					this.notionlist2 = data.children;
					this.notionlist3 = []; this.notionlist4 = [];
				} else if (step == 3) {
					this.notionlist3 = data.children; this.notionlist4 = [];
				} else if (step == 4) {
					this.notionlist4 = data.children; this.notionlist5 = [];
				} else if (step == 5) {
					this.notionlist5 = data.children;
				}
			}
			console.log(this.chooseNotionlist, this.chooseNotionlist[step - 1], step);
			// this.getlist1();
		},
		//获取产业政策列表
		getlist1(pages) {
			var ajpage = 1;
			if (pages) {
				ajpage = pages;
			}
			this.page = ajpage;
			var _this = this,
				dnotion = [];
			var notionja = this.splicing('notionList', this.notionCode);
			var kwja = this.splicing('kw', this.kw);
			var goodjia = this.splicing('good', this.radioid);
			var dateja = this.splicing('date', this.value);
			this.bus.$emit('loading', true);
			var ajaxurl = this.$api.cyl.news.list() + "?type=2&bigClass=30008" + '&page=' + ajpage + notionja + kwja + goodjia + dateja;
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log("产业政策链", ajaxurl, res);
				if (res.data.code < 1) {
					// console.log('zhengcejia',notionja);
					_this.pagelist1 = res.data.list;
					_this.bus.$emit('loading', false);
					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
					_this.maxPage = res.data.totalPage;
					_this.kwtextsearch = _this.kw != "";
					_this.kwtextsearchtext = _this.kw;
					_this.haspage = res.data.list.length == res.data.pageSize;
					if (type == 0) {
						for (var i = 0; i < _this.pagelist.length; i++) {
							dnotion.push({
								notion: _this.pagelist[i].notion,
								notionCode: _this.pagelist[i].notionCode
							});
						}
					}

				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//获取招商政策
		getlist2(pages) {
			let ajpage = 1;
			pages ? ajpage = pages : this.page = 1;
			this.page = ajpage;
			let province = this.splicing('province', this.provinceid);
			let city = this.splicing('city', this.cityid);
			let levelId = this.splicing('levelId', this.levelValue);
			let typeId = this.splicing('typeId', this.policyTypeValue);
			let orgId = this.splicing('orgId', this.postingValue);
			let tagId = this.splicing('tagId', this.policyLabelValue);
			let kwja = this.splicing('kw', this.kw);
			this.bus.$emit('loading', true);
			let ajaxurl = this.$api.free.policy.list() ;
			this.$axios.get(ajaxurl).then((res) => {
				console.log("招商政策列表", ajaxurl, res);
				if (res.data.success) {
					this.pagelist2 = res.data.list;
					this.totalPage = res.data.totalPage;
					this.pageSize = res.data.pageSize;
					this.total = res.data.totalRecord;
					this.kwtextsearch = this.kw != "";
					this.kwtextsearchtext = this.kw;
				} else {

				}
				this.bus.$emit('loading', false);
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		pageHandler: function (page) {
			if(page>1){
				this.isShowFreeUserTips = true;
				return;
			}
			// console.log(page);
			if(this.pageType == 1 ){
				this.getlist1(page);
			}else{
				this.getlist2(page);
			}
		},
		//搜索关键词
		searchkwfun() {
			this.isShowFreeUserTips = true;
			return;
			this.searchtext = $.trim(this.searchtext);
			if(this.pageType == 1){
				this.getlist1();
			}else{
				this.getlist2();
			}
		},
		searchenter(e) {
			if (e.keyCode == 13) {
				this.searchkwfun();
			}
		},
	},
}
</script>

<style>
.policylibrary  .info_title{
	font-size: 18px;
}
.indtry{
	width: 60%;
	/* text-overflow: ellipsis;
	white-space: normal;
	overflow: hidden; */
}</style>
